"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bolano": {
    "ddc1f5c7": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "montebello-di-cima": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bolano"
    }],
    "38de1919": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "montebello-di-fondo": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bolano"
    }],
    "db65cb52": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "montebello-di-mezzo": [{
      "hkey": "19d1b5b3",
      "slug": "montebello",
      "name": "Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bolano"
    }]
  }
};
exports["default"] = _default;